export default __webpack_public_path__ + "static/media/login.5ab26e60.png";